module.exports = __webpack_public_path__ + "media/images/bg-header-069e673fdc85dc5efd73d919ec67b324.jpg";